(function(){
var DESC = {
  'Humedad': 'Agua natural de la carne y verduras. Hidrata a tu perro en cada comida.',
  'Proteína': 'Construye músculo y repara tejidos. De carne y vísceras de calidad humana.',
  'Grasa': 'Energía concentrada y pelaje brillante. Principalmente del aceite de oliva.',
  'Carbohidratos': 'Energía de liberación gradual. De la patata y la avena integral.',
  'Fibra bruta': 'Digestión regular y cacas firmes. De verduras y cereales enteros.'
};
function init(){
  var center = document.querySelector('.nc-r-nu__center');
  var rows = document.querySelectorAll('.nc-r-nu__row');
  var svg = document.querySelector('.nc-r-nu__chart svg');
  var circles = svg ? svg.querySelectorAll('circle') : [];
  if(!center || !rows.length) return;
  var valEl = center.querySelector('.nc-r-nu__cv');
  var lblEl = center.querySelector('.nc-r-nu__cl');
  var descEl = center.querySelector('.nc-r-nu__cd');
  if(!descEl){ descEl = document.createElement('div'); descEl.className='nc-r-nu__cd'; center.appendChild(descEl); }

  // NORMALIZAR: recalcular los arcos para que sumen 100% del círculo
  // (porque los porcentajes a veces suman 94-97% por redondeos)
  if (circles.length) {
    var CIRC = 502.65; // 2 * PI * 80
    // Parsear los valores reales desde las rows
    var values = [];
    for (var i=0;i<rows.length;i++){
      var rv = rows[i].querySelector('.nc-r-nu__rv');
      if (!rv) continue;
      var txt = rv.textContent.replace(',', '.').replace('%', '').trim();
      values.push(parseFloat(txt) || 0);
    }
    var total = 0;
    for (var i=0;i<values.length;i++) total += values[i];
    if (total > 0) {
      var offset = 0;
      for (var i=0;i<circles.length && i<values.length;i++) {
        var len = values[i] * CIRC / total;  // Normalizado al total real
        var gap = CIRC - len;
        circles[i].setAttribute('stroke-dasharray', len + ' ' + gap);
        circles[i].setAttribute('stroke-dashoffset', -offset);
        offset += len;
      }
    }
  }

  // Crear capa de hit-targets invisibles (stroke grueso) para facilitar clicks
  var hitCircles = [];
  if (svg && circles.length) {
    var hitLayer = document.createElementNS('http://www.w3.org/2000/svg','g');
    hitLayer.setAttribute('class','nc-r-nu__hitlayer');
    for (var i=0;i<circles.length;i++){
      var orig = circles[i];
      var hit = document.createElementNS('http://www.w3.org/2000/svg','circle');
      hit.setAttribute('cx', orig.getAttribute('cx'));
      hit.setAttribute('cy', orig.getAttribute('cy'));
      hit.setAttribute('r', orig.getAttribute('r'));
      hit.setAttribute('stroke', 'transparent');
      hit.setAttribute('stroke-width', '64');
      hit.setAttribute('fill', 'none');
      hit.setAttribute('stroke-dasharray', orig.getAttribute('stroke-dasharray'));
      hit.setAttribute('stroke-dashoffset', orig.getAttribute('stroke-dashoffset'));
      hit.style.cursor = 'pointer';
      hit.style.pointerEvents = 'stroke';
      hitLayer.appendChild(hit);
      hitCircles.push(hit);
    }
    svg.appendChild(hitLayer);
  }

  function pick(i){
    var r = rows[i]; if(!r) return;
    var n = r.querySelector('.nc-r-nu__rn').textContent.trim();
    var v = r.querySelector('.nc-r-nu__rv').textContent.trim();
    var d = r.querySelector('.nc-r-nu__dot');
    var color = d ? getComputedStyle(d).backgroundColor : '';
    valEl.textContent = v; lblEl.textContent = n;
    descEl.textContent = DESC[n] || '';
    if(color) valEl.style.color = color;
    for(var j=0;j<rows.length;j++){ rows[j].classList.toggle('nc-r-nu__row--active', j===i); }
    for(var j=0;j<circles.length;j++){ circles[j].classList.toggle('nc-r-nu__circle--active', j===i); }
  }

  function bind(el, idx){
    el.style.cursor='pointer';
    el.addEventListener('click', function(e){ e.preventDefault(); pick(idx); });
    el.addEventListener('mouseenter', function(){ pick(idx); });
    el.addEventListener('touchend', function(e){ e.preventDefault(); pick(idx); }, {passive:false});
  }

  for(var i=0;i<rows.length;i++){ bind(rows[i], i); }
  for(var i=0;i<circles.length;i++){ bind(circles[i], i); }
  for(var i=0;i<hitCircles.length;i++){ bind(hitCircles[i], i); }

  var p=-1;
  for(var i=0;i<rows.length;i++){
    if(rows[i].querySelector('.nc-r-nu__rn').textContent.trim()==='Proteína'){p=i;break;}
  }
  if(p>=0) pick(p);
}
if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();